// extracted by mini-css-extract-plugin
export default {"wrap":"messages_wrap__o9jX5"};